:host {
  display: block;
}

.link-upload-container {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: var(--margin-xl);
  align-items: center;
  margin-bottom: var(--margin);
}

.url-input-wrapper {
  display: flex;
  flex-direction: column;
}

.file-upload-wrapper {
  display: flex;
  flex-direction: column;
}

.or-divider {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
  text-transform: uppercase;
}

.url-input {
  width: 100%;
  padding: var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-size: var(--font-size);
}

.url-input:focus {
  outline: none;
  border-color: var(--color-bg-accent);
  box-shadow: var(--box-shadow);
}

.file-input {
  padding: var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  background: var(--color-bg-primary);
  cursor: pointer;
}

.input-label {
  font-size: var(--font-size-s);
  color: var(--color-text-secondary);
  margin-bottom: var(--margin-s);
}

.upload-status {
  font-size: var(--font-size-s);
  color: var(--color-bg-accent);
  margin-top: var(--margin-s);
  display: block;
}

.uploading {
  opacity: 0.6;
  pointer-events: none;
}

.preview-container {
  margin-top: var(--margin);
}

.image-preview {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: var(--border-radius);
  border: var(--border);
}

@media (max-width: 768px) {
  .link-upload-container {
    grid-template-columns: 1fr;
    gap: var(--margin);
  }
  .or-divider {
    text-align: center;
  }
}
